export const Languages = {
  en: "en",
  cn: "cn",
};

export const defaultLanguage = Languages.en;
